import React from 'react';
import { ReactComponent as Logo } from 'src/assets/images/breathe_logo.svg';
import { Link } from 'react-router-dom';
import { StyledHeaderInnerContainer, Container } from './styles';

export const Header = () => (
  <header>
    <Container>
      <StyledHeaderInnerContainer>
        <Link to="/">
          <Logo />
        </Link>
      </StyledHeaderInnerContainer>
    </Container>
  </header>
);
